import { render, staticRenderFns } from "./EmptyCallView.vue?vue&type=template&id=54d87d57&scoped=true"
import script from "./EmptyCallView.vue?vue&type=script&lang=js"
export * from "./EmptyCallView.vue?vue&type=script&lang=js"
import style0 from "./EmptyCallView.vue?vue&type=style&index=0&id=54d87d57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d87d57",
  null
  
)

export default component.exports